import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from '../../ui/Button';
import { useNavigate } from 'react-router-dom';

export const AdminButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate('/admin-dashboard')}
      className="h-9 w-9"
      title="Tableau de bord administrateur"
    >
      <ShieldCheck className="h-5 w-5" />
    </Button>
  );
};